import React from 'react'
import CompaniesBargraps from '../../components/super-admin/dashbaord/CompaniesBargraps'
import CompaniesList from '../../components/super-admin/dashbaord/CompaniesList'

const CompaniesButton = () => {
  return (
    <div style={{ padding: "15px", background: "#f8f9fa", height: "100vh" }} >
      <CompaniesBargraps/>
      <CompaniesList/>
    </div>
  )
}

export default CompaniesButton
